/* 8ease homepage modules — shared behaviour
   - Scroll reveal for [data-e8-reveal] (staggered via --i)
   - Horizontal card scrollers ([data-e8-scroller]) with prev/next buttons
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('[data-e8-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- scroller ---------- */
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-e8-scroller]').forEach(function (wrap) {
      if (wrap.dataset.e8Ready) return;
      wrap.dataset.e8Ready = '1';
      var track = wrap.querySelector('[data-e8-track]');
      var prev = wrap.querySelector('[data-e8-prev]');
      var next = wrap.querySelector('[data-e8-next]');
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        wrap.classList.toggle('has-overflow', track.scrollWidth > track.clientWidth + 2);
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) { initReveal(root); initScrollers(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.E8 = window.E8 || {};
  window.E8.init = init;
})();
